import { createApiSlice } from "@common";
import { CRUD_INTENT_LEVEL } from "@routes";

const apiConfig = [
  {
    name: "addIntentLevel",
    method: "post",
    url: CRUD_INTENT_LEVEL,
    stateKey: "message",
  },
  {
    name: "getIntentLevel",
    method: "get",
    url: CRUD_INTENT_LEVEL,
    stateKey: "data",
  },
  {
    name: "updateIntentLevel",
    method: "put",
    url: CRUD_INTENT_LEVEL,
    stateKey: "message",
  },
  {
    name: "deleteIntentLevel",
    method: "delete",
    url: CRUD_INTENT_LEVEL,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("intentLevel", apiConfig, customReducers);
const intentLevelSlice = slice;

export default intentLevelSlice.reducer;

export const {
  addIntentLevel,
  getIntentLevel,
  updateIntentLevel,
  deleteIntentLevel,
} = thunks;

export const { rowSelect } = actions;
